import { graphql } from "../../generated/gql";

export const OptimizeTextGQL = graphql(`
  mutation OptimizeText($input: OptimizeTextInput!) {
    optimizeText(input: $input) {
      optimizedText
    }
  }
`);
